export const DEFAULT_CHAT_ENDPOINT = 'https://api.openai.com/v1/chat/completions';

export const DEFAULT_CHAT_NODE_TIMEOUT = 30_000;
